import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { MDBDatePickerComponent, ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { SaldoStockService } from 'src/app/services/saldo-stock.service';
import { MovimientoStockService } from 'src/app/services/movimiento-stock.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { BodegaService } from 'src/app/services/bodega.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import gql from 'graphql-tag';

export interface IDepositoAgregado {
  banco: number | string,
  nombreBanco: string,
  cuenta: number | string,
  nroDeposito: number | string,
  fechaDeposito: Date | string,
  tipo_cuenta_bancaria_codigo: number
}

@Component({
  selector: 'app-modal-reserva-combo',
  templateUrl: './modal-reserva-combo.component.html',
  styleUrls: ['./modal-reserva-combo.component.scss']
})
export class ModalReservaComboComponent implements OnInit {

  @ViewChild('datePickerFechaDeposito', { static: true }) datePickerFechaDeposito: MDBDatePickerComponent
  @ViewChild('reservaCombo', { static: true }) modalReservaCombo: ModalDirective;

  @Output() onSuccess: EventEmitter<any> = new EventEmitter<any>();

  // Contants
  readonly MOVIMIENTO_ENTRADA: String = "_MOVIMIENTO_ENTRADA_"
  readonly MOVIMIENTO_SALIDA: String = "_MOVIMIENTO_SALIDA_"

  // Form
  formHeader: FormGroup
  initialValues: any

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalEmpresa: number;
  loading: boolean = false
  listaProductosComboAll: Array<any> = null
  listaProductosCombo: Array<any> = null
  optionsBodega: Array<any> = [];
  private codigoCombo: Number = -1
  private operacion: Number = -1
  mainTotalPaginas: number
  mainTotalRegistros: number
  paginationContext: PaginationContext = new PaginationContext()
  dateTime: Date
  descripcion: string
  allowSave: boolean = false

  // Utils
  private log: any

  constructor(
    private gqlclient: GraphQLClient,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private bodegaServ: BodegaService,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private rutService: RutService,
    private datesService: DatesService,
    private saldoStockService: SaldoStockService,
    private movimientoStockService: MovimientoStockService,
  ) {
    this.log = this.clog.log('RESERVA-COMBO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());

    this.loadBodegas()
    this.setDateTime()
    this.createForm()
    this.formChangesSubscriptions()
    this.reset()
  }

  trackByProductoCombo(index: number, item: any) {
    return item && item.producto_codigo != null ? item.producto_codigo : (item && item.sku ? item.sku : index);
  }

  loadBodegas() {
    this.bodegaServ.GetBodegas(this.rutEmpresa, this.sucursalEmpresa, ({ mensajes, respuesta }) => {
      const { registros } = respuesta
      this.optionsBodega = registros.map(bodega => ({
        value: bodega.codigo,
        label: bodega.nombre,
        sucursal_codigo: bodega.sucursal_codigo, codigo: bodega.codigo
      }))
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('bodega'), this.optionsBodega)
    })
  }

  setDateTime() {
    this.dateTime = new Date()
    setInterval(() => {
      this.dateTime = new Date()
    }, 1000)
  }

  private createForm() {
    this.formHeader = this.fb.group({
      bodega: [null, [Validators.required]],
      cantidad: [0, [Validators.required, Validators.min(0)]],
      movimientoEntradaOrSalida: [this.MOVIMIENTO_ENTRADA, [Validators.required]],
    });

    this.initialValues = {
      bodega: null,
      cantidad: null,
      movimientoEntradaOrSalida: null,
    }
  }

  formChangesSubscriptions() {
    this.formHeader.get("bodega").valueChanges.subscribe(bodega_codigo => {
      if (!bodega_codigo) {
        //this.formHeader.get('cantidad').setValue(0)
        return
      }
      this.getSaldo(bodega_codigo, this.codigoCombo)
    })

    this.formHeader.get("cantidad").valueChanges.subscribe(cant => {
      if (!cant) {
        return
      }
      this.getListProducto(cant)
    })
  }

  getListProducto(cant) {
    if (this.listaProductosCombo != null){
      this.listaProductosCombo.forEach(element => {
        element.reserva = element.cantidad * cant
      });
    }
  }

  getSaldo(bodega_codigo, codigoCombo) {
    this.saldoStockService.obtenerSegunId(
      this.rutEmpresa, this.sucursalEmpresa, bodega_codigo, codigoCombo, ({ mensajes, respuesta }) => {
        if (respuesta != null) {
          this.formHeader.get('cantidad').setValue(respuesta.stock_disponible)
          this.formHeader.get('cantidad').markAsPristine()
          this.formHeader.get('cantidad').markAsUntouched()
        } else {
          this.formHeader.get('cantidad').setValue(0)
          this.getListProducto(this.formHeader.get('cantidad').value)
        }
      })
  }

  setInitialValues(codigo: number) {
    this.codigoCombo = codigo
    this.formValidatorsService.setDefaultValues(this.formHeader, this.initialValues)
    //this.enableFormHeader()
    this.formValidatorsService.reset(this.formHeader)
    //this.datePickerFechaDeposito.clearDate()
    // this.formValidatorsService.setDefaultValues(this.formHeader, this.initialValues)
    //const now = this.datesService.CurrentDateToShortTimeString()
    //this.formHeader.get('fechaDeposito').setValue(now)
    //this.disableGuardar()
    this.reset()
  }

  reset() {
    // this.enableFormHeader()
    this.listaProductosComboAll = null
    this.listaProductosCombo = null
    this.mainTotalPaginas = null
    this.mainTotalRegistros = null
    this.formHeader.get('movimientoEntradaOrSalida').setValue(this.MOVIMIENTO_ENTRADA)
    this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('bodega'), this.optionsBodega)
  }

  load(empresa_rut, codigo) {
    //this.disabledContent = !allowEdit
    this.setInitialValues(codigo)
    const _variables = {
      empresa_rut,
      sucursal_codigo: this.sucursalEmpresa,
      codigo
    }

    //this.loaded = false
    this.loading = true

    const self = this
    this.gqlclient.query(
      {
        query: gql`
        query ($empresa_rut: Decimal, $codigo: Decimal) {
          producto {
            obtenerSegunFiltroProductosCombo(filtro: {exacto: {empresa_rut: $empresa_rut, tipobusqueda_estado: 3, fecha_inicio_combo: "01-01-0001", fecha_caducidad_combo: "01-01-0001", tipo_cliente: [], rut_cliente_multiple: [], codigo: $codigo, sku: ""}}) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  sku
                  descripcion
                  activo
                  familia_codigo
                  tipo_producto_codigo
                  fecha_caducidad_combo
                  fecha_inicio_combo
                  rubro_codigo
                  precio_unitario_combo
                }
              }
            }
          }
          combo_detalle {
            obtenerSegunFiltro(filtro: {exacto: {combo_producto_codigo: $codigo, empresa_rut: $empresa_rut, combo_formato_codigo: "", producto_codigo: -1}}) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  producto_codigo
                  empresa_rut
                  combo_producto_codigo
                  combo_formato_codigo
                  cantidad
                  descripProducto
                  descripFormato
                  sku
                }
              }
            }
          }
        }        
        `,
        variables: _variables,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        // Header
        const { respuesta: respHeader } = response.data.producto.obtenerSegunFiltroProductosCombo
        const { registros: headerData } = respHeader

        //self.formHeader.get('activo').setValue(headerData[0].activo)//: [0],
        //self.formHeader.get('fechaInicio').setValue(headerData[0].fecha_inicio_combo)//: ['', [Validators.required]],
        //self.formHeader.get('fechaFin').setValue(headerData[0].fecha_caducidad_combo)//: ['', [Validators.required]],
        //self.formHeader.get('codigoProductoNuevo').setValue(headerData[0].sku)//: [0, [Validators.required, Validators.min(1)]],
        //self.formHeader.get('precio').setValue(headerData[0].precio_unitario_combo)//: [0, [Validators.required, Validators.min(1)]],
        self.descripcion = headerData[0].descripcion//: ['', [Validators.required]]

        const { mensajes, respuesta: respDetalles } = response.data.combo_detalle.obtenerSegunFiltro
        const { registros: productsData, paginaActual, totalPaginas, totalRegistros } = respDetalles

        // Products
        self.listaProductosCombo = productsData.map((producto, index) => ({
          producto_codigo: producto.producto_codigo,
          rut_emisor: producto.empresa_rut,
          sku: producto.sku,
          producto_descripcion: producto.descripProducto,
          formato_codigo: producto.combo_formato_codigo,
          formato_nombre: producto.descripFormato,
          cantidad: producto.cantidad,
          reserva: producto.cantidad * self.formHeader.get("cantidad").value,
          index
        }));

        self.modalReservaCombo.show()
      }
    );
  }

  guardarReserva() {
    const listaProductosCombo = _.cloneDeep(this.listaProductosCombo)
    listaProductosCombo.map(p => {
      delete p.additionalData
      delete p.__typename
      delete p.index
    })

    if (this.formHeader.get('movimientoEntradaOrSalida').value === "_MOVIMIENTO_ENTRADA_") {
      this.operacion = 1
    } else {
      this.operacion = -1
    }

    const inputParams = {
      operacion: this.operacion,
      entidad:
      {
        rut_emisor: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        bodega_codigo: this.formHeader.get('bodega').value,
        producto_codigo: this.codigoCombo,
        cantidad: this.formHeader.get('cantidad').value,
        listaProductosCombo
      }
    }

    this.log('inputParams', JSON.stringify(inputParams))
    this.movimientoStockService.guardarReservaCombo(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      //const { registros, totalPaginas, totalRegistros } = respuesta

      // this.enableFormHeader()
      this.reset()

      // const index: string = this.depositoDocumentoService.guardarPayload({ registros, totalPaginas, totalRegistros })
      this.toastService.success('Operación exitosa')
      this.modalReservaCombo.hide()
      this.onSuccess.emit()
      // this.router.navigate(['/finanzas/timbrarDeposito', index])
    })
  }
}
